import { Alert, Typography } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ToolWidget from '../../components/public-tools/ToolWidget';

export default function Ga4OnPageValidationPage() {
  return (
    <PublicToolLayout title="GA4 On-Page Validation">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        GA4 On-Page Validation
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Analyze a public URL for GA4 installation signals, tracking opportunities, and readiness recommendations
        by inspecting page source and DOM signals only.
      </Typography>
      <Alert severity="info" sx={{ mb: 3 }} icon={false}>
        This check validates on-page readiness only. Account-level settings such as conversions, attribution,
        and GA4 property configuration require GA4 account access.
      </Alert>
      <ToolWidget
        scanType="GA4"
        formLabel="Website URL"
        formPlaceholder="https://example.com"
      />
    </PublicToolLayout>
  );
}
